export enum ConnectionType {
  WS = 'WS',
  POLLING = 'POLLING'
}
